import {
  getTrialBalanceRows,
  getTrialBalanceColumns,
} from "./trial-balance-statement";
import { getTrialBalance } from "@/api/finance/reportApi";
import { DynamicReport } from "@/components/dynamic";

const trialBalanceFilters = {};

const trialBalanceFilterOptions = [
  { key: "component", apiKey: "ComponentId" },
  { key: "company", apiKey: "Company" },
];

export default function ReportTrialBalance({
  activeCompany,
  accountingPeriod,
}) {
  return (
    <DynamicReport
      reportName="trial-balance"
      activeCompany={activeCompany}
      columnsDataProvider={getTrialBalanceColumns}
      rowsDataProvider={getTrialBalanceRows}
      fetchData={getTrialBalance}
      exportUrl="finance/reports/trial-balance/xls"
      filtersInitialState={trialBalanceFilters}
      filterOptions={trialBalanceFilterOptions}
      orderBy="code"
      accountingPeriod={accountingPeriod}
      showDateRangeFilter
      startDate={new Date()}
      endDate={new Date()}
      isPaginated={false}
      accountingPeriodEnabled
    />
  );
}
